import React, { useState, useEffect } from 'react';
import { Card, Image, notification,Spin, Row, Col  } from "antd";
import { useParams} from "react-router-dom"; 

import { getProduction, getProductionAvailables } from '../API';

import './production.css';

const ProductionEstimation = () => {
  const [spinning, setSpinning] = useState(false);
  const [startSeason, setStartSeason] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState('');
  const [seasonYear, setSeasonYear] = useState(0);
  const [selectedSeasonOptimal, setSelectedSeasonOptimal] = useState('');
  const [estimatedImage, setEstimatedImage] = useState('');
  const [estimatedTons, setestimatedTons] = useState(0);

  const [initialDates, setInitialDates] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const buttonDisabled = true;  
  
  const { cropid } = useParams();

  const paths=[];

  useEffect(() => {
    getProduction(cropid).then((cropDates) => {
      setStartSeason(cropDates);
    });
  }, [cropid]);

  const estimate= async function(){
    let fdata=new FormData();
      
    fdata.append('year', seasonYear);
    paths.forEach(function(v,k){
      fdata.append('p'+k,v)
    });

    try {
      const response = await fetch("/api/crops/estimate",{
        method: 'POST',
        body: fdata        
      });

      if (!response.ok) {
        throw new Error('Error al hacer la petición');
      }else{
        const data = await response.json();
        setSpinning(false);
        
        console.log('Respuesta de la petición:', data);
        setEstimatedImage('/api/crops/imagemap/'+data.image);
        setestimatedTons(data.tonxha);
      }
    } catch (error) {
      setSpinning(false);
    }
  }

  const fetchDataRecursively = async (counter) => {
    if (counter === 0) {
      console.log('Petición recursiva completada');
      
      estimate();
      return;
    }
    var arr=selectedDates.sort();

    let url=cropid+'/'+(arr[4-counter]).replace('/','-');

    try {
      const response = await fetch("/api/crops/getremote/"+url);
      if (!response.ok) {
        throw new Error('Error al hacer la petición');
      }

      const data = await response.json();
      paths.push(data.path);

      fetchDataRecursively(counter - 1);
    } catch (error) {
      console.error('Error en la petición:', error);
      setSpinning(false);
    }
  };

  const estimar=function(){
    setSpinning(true);
    fetchDataRecursively(4);
  }

  function processSelectedSeason(xvalue){
    let value=xvalue.replace(' GMT','');
    setSelectedDates([]);
    setInitialDates([]);
    setEstimatedImage('');
    setestimatedTons(0);
    var firstDate = new Date(value);
    setSeasonYear(firstDate.getFullYear());
    var lastDate = new Date(firstDate);
    lastDate.setMonth(firstDate.getMonth() + 6);
    lastDate.setDate(1);
    
    let elastDate = lastDate.toISOString().slice(0, 10);

    const opcionesDeFormato = { day: '2-digit', month: 'long', year: 'numeric' };
    const formato = new Intl.DateTimeFormat('es-ES', opcionesDeFormato);
  
    setSelectedSeason(formato.format(firstDate));
    setSelectedSeasonOptimal(formato.format(lastDate));

    getProductionAvailables(cropid,elastDate).then((cropDates) => {
      if(cropDates.created_at&&cropDates.created_at.length>0 && cropDates.model && cropDates.meteoro){
        if(cropDates.created_at.length>=4){          
          setInitialDates(cropDates.created_at)
        }else{
          //avisa aqui notificication
        }
      }else{
        notification.info({
          'message':'Modelo y/o datos meteorológicos no disponibles',
          'description': 'La estimación no puede ser calculada'
        });        
      }
      //console.log(cropDates);
    });

  }

  const handleCheckboxChange = (date) => {
    if (selectedDates.includes(date)) {
      setSelectedDates(selectedDates.filter(d => d !== date));
    } else {
      setSelectedDates([...selectedDates, date]);
    }
  };  

  return (
    <div className="ProductionEstimation" style={{'width':'100%'}}>
      <div className={`mon-spin-fullscreen ${spinning ? 'active' : ''}`} >
        <Spin size="large" />
      </div>

      <Row style={{width:'100%'}}>
        <Col span={11}>
          <Card >
            <label>Estimación de producción&nbsp;&nbsp;</label>
            <select value={selectedSeason} onChange={(e) => processSelectedSeason(e.target.value)}>
              <option value="">Selecciona una temporada</option>
              {startSeason.map((season, index) => (
                <option key={index} value={season.sos}>
                  {season.ciclo}
                </option>
              ))}
            </select>

            {selectedSeason && (
        <div className='section-production'>
          <Card>
            <p>Información de la temporada seleccionada:</p>
            {/* Muestra más información según tus necesidades */}
            <p>{`Fecha de inicio: ${selectedSeason}`}</p>
            <p>{`Fecha óptima de estimación: ${selectedSeasonOptimal}`}</p>
          </Card>

          {initialDates.length >= 4 ? (
                <Card style={{ width: "100%" }} >
                <p>Escenas seleccionadas [{selectedDates.length} de 4]</p>
                <div className='has-4'>
                {initialDates.map((date, index) => (
                  <div key={index}>
                    <label>
                    <input
                      type="checkbox"
                      value={date}
                      checked={selectedDates.includes(date)}
                      onChange={() => handleCheckboxChange(date)}
                      disabled={selectedDates.length === 4 && !selectedDates.includes(date)}
                    />
                    <span> {date}</span>
                    </label>
                  </div>
                ))}
                </div>
                <button onClick={estimar} disabled={selectedDates.length <= 3}>{buttonDisabled}Estimar</button>
              </Card>

          ) : (
            <div className='warning'>
              <p>No hay suficientes escenas para estimar la producción y/o el modelo de predicción no está disponible</p>
            </div>
          )}          

        </div>
      )}


          </Card>
        </Col>
        {estimatedTons>0 && estimatedImage!==''?(
        <Col span={10}>
          <Card>
          {estimatedTons>0?(
              <p>
                <center>
                  <i>Estimado aproximado</i>
                  <h1>{estimatedTons}<small style={{fontSize:'.5em'}}>ton/ha</small></h1>
                </center>
              </p>
            ):''}
            {estimatedImage!==''?(
              <Image src={estimatedImage}></Image>
            ):''}            
          </Card>          
        </Col>
        ):''}
      </Row>


    </div>
  );
};

export default ProductionEstimation;